import React from "react";
import Banner from "../Components/Banner";

const Pricing = () => {
  const plans = [
    {
      title: "Website Development",
      text: "Custom, responsive websites built for performance and scalability.",
      price: "PKR 1,000 – 15,000+",
      features: [
        "Corporate Websites",
        "E-commerce Platforms",
        "Web Applications",
        "CMS Integration",
      ],
    },
    {
      title: "App Design & Development",
      text: "Cross-platform mobile applications for iOS and Android.",
      price: "PKR 2,000 – 20,000+",
      features: [
        "Native & Cross-Platform",
        "API Integration",
        "App Store Deployment",
        "Maintenance",
      ],
    },
    {
      title: "UI/UX Designing",
      text: "User-centric interfaces that drive engagement and conversions.",
      price: "PKR 5,00 – 5,000+",
      features: [
        "Wireframing & Prototyping",
        "User Research",
        "Interactive Design",
        "Brand Consistency",
      ],
    },
    {
      title: "Machine Learning & AI",
      text: "Advanced data models and intelligent automation for your business.",
      price: "PKR 5,000 – 30,000+",
      features: [
        "Predictive Analytics",
        "Natural Language Processing",
        "Custom Algorithms",
        "Data Processing",
      ],
    },
    {
      title: "Digital Marketing",
      text: "Strategic campaigns to boost your online visibility and growth.",
      price: "PKR 5,00 – 30,000+",
      features: [
        "SEO Optimization",
        "Social Media Management",
        "Paid Advertising (PPC)",
        "Content Strategy",
      ],
    },
  ];

  return (
    <>
      <Banner heading="Pricing Transparency" text="Pricing Transparency" />

      <div className="bg-gradient-to-b from-[#0b0f2a] to-[#0a0d1f] text-white py-20 px-4">
        <div className="max-w-6xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold text-white">
            Transparent Pricing <br />
            <span className="text-blue-400">for Custom Solutions</span>
          </h2>
          <p className="mt-4 text-gray-300 max-w-2xl mx-auto">
            At HNH Soft Tech Solutions Pvt Ltd, every project is unique.
            Below are typical pricing ranges for our core services. Final
            pricing depends on your project scope.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className="bg-[#11152c] border border-gray-700 rounded-2xl p-6 shadow-lg hover:scale-105 transition flex flex-col justify-between min-h-[420px]"
            >
              {/* Top Content */}
              <div>
                <h1 className="text-2xl font-semibold mb-2 text-white">
                  {plan.title}
                </h1>

                <p className="text-gray-400 mb-6 text-xl leading-relaxed">
                  {plan.text}
                </p>

                <div className="bg-[#0b0f2a] rounded-lg p-4 mb-6">
                  <p className="text-xl text-blue-400 uppercase tracking-wide">
                    Typical Range
                  </p>
                  <p className="text-2xl font-bold text-white mt-1">
                    {plan.price}
                  </p>
                </div>

                <ul className="space-y-2 text-gray-300 text-sm mb-6">
                  {plan.features.map((item, i) => (
                    <li key={i} className="flex items-center gap-2">
                      <span className="text-blue-400">✔</span> {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Button Bottom Fixed */}
              <button className="w-full mt-auto bg-gradient-to-r from-purple-500 to-blue-500 py-2 rounded-lg font-medium hover:opacity-90">
                Request Custom Quote
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Pricing;